import React, { useEffect, useState } from 'react';
import { fetchAccessToken } from './utils/token';
import { getAllStores } from './services/getAllStores';
import { EXPIRY_TIME } from './utils/constants';
import { Toaster } from 'react-hot-toast';
import { ModalProvider } from './context/modalContext';
import { useApp } from './context/appContext';
import { useSearchParams } from 'react-router-dom'; // To read query params
import { fbApiUrl } from "./components/shared/facebooktrack_config";  

import MapScreen from './components/MapScreen';
import ListingScreen from './components/ListingScreen';
import DatePickerScreen from './components/DatePickerScreen';
import FormScreen from './components/FormScreen';
import ConfirmationScreen from './components/ConfirmationScreen';
import LoadingScreen from './components/LoadingScreen';

const App = () => {
  const { currentPage, setCurrentPage, setForm } = useApp();
  const [loading, setLoading] = useState(true);
  const [stores, setStores] = useState([]); // State to store fetched stores data
  const [searchParams, setSearchParams] = useSearchParams(); // Hook to get query params




  useEffect(() => {
    const sendDataToFacebookAPI = async () => {
        if (!fbApiUrl) {
          console.error("Error: fbApiUrl is not defined!");
        } 
        else {
          try{
        
            const ipResponse = await fetch("https://api64.ipify.org?format=json");
            const ipData = await ipResponse.json();
            const clientIp = ipData.ip; // Extracted IP Address

            // Get User Agent
            const userAgent = navigator.userAgent;

            const data = {
              data: [
                {
                  event_name: "View Booking App",
                  event_time: Math.floor(Date.now() / 1000),
                  user_data: {
                    client_ip_address: clientIp,
                    client_user_agent: userAgent,
                  },
                  action_source: "website",
                },
              ],
              test_event_code: "TEST58912",
            };
          
            const response = await fetch(fbApiUrl, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(data),
            });
        
            const result = await response.json();
            // console.log("result", result);
            // return;
          }
          catch (error) {
            console.error("Error sending data to Facebook API:", error);
          }
        }
    };

    sendDataToFacebookAPI();
  }, []); // Runs only on component mount


  
  useEffect(() => {
    const fetchData = async () => {
      try {
        await fetchAccessToken(); // Fetch access token
        const fetchedStores = await getAllStores(); // Fetch all stores
        const filteredStores = fetchedStores.filter(store => store.Brand__c === "Optical Superstore");
        setStores(filteredStores); // Store only filtered stores data
        setLoading(false); // Set loading to false when data is fetched

        console.log(filteredStores);

        // Check if locationId exists in the query string
        const locationId = searchParams.get('locationId');
        if (locationId) {
          const validStore = filteredStores.find(store => store.Id === locationId);
          if (validStore) {
            setForm(prevForm => ({
              ...prevForm,
              location: validStore
            }));
            setCurrentPage('date-picker'); // Navigate to date-picker page
          } else {
            // Invalid locationId: Redirect to default page and remove query param
            searchParams.delete('locationId');
            setSearchParams(searchParams);
            setCurrentPage('map');
          }
        }


      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false); // Ensure loading is false even in case of an error
        // You can display a toast or show an error screen if needed
      }
    };

    fetchData(); // Trigger the API calls

    const interval = setInterval(fetchAccessToken, EXPIRY_TIME); // Refresh token periodically
    return () => clearInterval(interval);
  }, []); // Empty dependency array ensures this runs only once when the component mounts

  const renderPage = () => {
    if (loading) {
      return <LoadingScreen />; // Show loading screen if data is still being fetched
    }

    switch (currentPage) {
      case 'map':
        return <MapScreen stores={stores} />; // Pass stores to MapScreen
      case 'listing':
        return <ListingScreen stores={stores} />; // Pass stores to ListingScreen
      case 'date-picker':
        return <DatePickerScreen />;
      case 'form':
        return <FormScreen />;
      case 'confirmation':
        return <ConfirmationScreen />;
      default:
        return <MapScreen stores={stores} />;

    }
  };

  return (
    <ModalProvider>
      {renderPage()}
      <Toaster position="top-center" toastOptions={{ duration: 3000 }} />
    </ModalProvider>
  );
};

export default App;
